import { useEffect } from 'react';
import { useMutableRef } from '@carnica/utils/hooks';
import { useChatStartAnalytics, ymPushAnswerMesBot } from "../../../../shared/analytics";
import { MessageStatus, OperationResultCode, WSMessageType, fromSocketToHistoryMessage } from "../../../../shared/api";
import { AssistantCodeName, DEFAULT_BROWSER_NOTIFICATION, IncomingMessageText } from "../../../../shared/config";
import { FSMStages, useAppDispatch, useAppSelector, useFSM, useScrollContext } from "../../../../shared/model";
import { useBrowserNotification } from "../../../../entities/notification/lib";
import { removeQueuedMessage, selectQueuedMessages } from "../../../../entities/captcha/model";
import { addQuickReplies } from "../../../../entities/content/model";
import { addMessage, addUnreadedMessage, updateMessage, updateSession } from "../../../../entities/message/model";
import { useSocketContext } from "../../../../entities/socket/model";
import { setCurrentApper } from "../../../../entities/user/model";
import { selectChatCofig } from "../../../../entities/settings/model";
import { useOnlineStatus } from "../../../../shared/lib";
export var useSocketService = function useSocketService() {
  var _useSocketContext = useSocketContext(),
    addEventHandler = _useSocketContext.addEventHandler;
  var dispatch = useAppDispatch();
  var sentChatStartAnalytics = useChatStartAnalytics();
  var _useAppSelector = useAppSelector(selectChatCofig),
    authZoneConfig = _useAppSelector.authZoneConfig;
  var scrollDataRef = useMutableRef(useScrollContext());
  var _useFSM = useFSM(),
    changeStage = _useFSM.changeStage;
  var _useBrowserNotificati = useBrowserNotification(DEFAULT_BROWSER_NOTIFICATION),
    addNotification = _useBrowserNotificati.addNotification;
  var queuedMessagesRef = useMutableRef(useAppSelector(selectQueuedMessages));
  var isOnlineRef = useMutableRef(useOnlineStatus());
  var onOpen = function onOpen() {
    return changeStage(FSMStages.ACTIVE);
  };
  var onClose = function onClose() {
    if (isOnlineRef.current) {
      changeStage(FSMStages.CONNECTING);
    }
  };
  var onMessage = function onMessage(e) {
    var message = JSON.parse(e.data);
    if (message.type === WSMessageType.SocketConnectionResult) {
      dispatch(setCurrentApper(message.data.assistantCodeName || AssistantCodeName.fluffy));
    }
    if (message.type === WSMessageType.OperationResult) {
      var successMessage = message.data.text;
      if (successMessage === IncomingMessageText.sessionInitialized) {
        sentChatStartAnalytics();
        dispatch(updateSession(message));
      }
      var _ref = message,
        data = _ref.data;

      // Установка статуса MessageStatus.delivered при успешном ответе от WS для текстовых сообщений и файлов
      if (successMessage === IncomingMessageText.messageSent || successMessage === IncomingMessageText.fileMessageSent) {
        if (queuedMessagesRef.current.find(function (_ref2) {
          var messageId = _ref2.messageId;
          return messageId === data.requestId;
        })) {
          dispatch(removeQueuedMessage(data.requestId));
        }
        var imgMessageStatus = message.data.code === OperationResultCode.success && message.data.action === 1 ? MessageStatus.delivered : MessageStatus.failed;
        dispatch(updateMessage({
          id: data.requestId,
          date: data.timestamp,
          messageStatus: successMessage === IncomingMessageText.fileMessageSent ? imgMessageStatus : MessageStatus.delivered
        }));
      }
    }
    if (message.type === WSMessageType.IncomingMessage || message.type === WSMessageType.OutgoingMessage) {
      var _fromSocketToHistoryM = fromSocketToHistoryMessage(message),
        historyMessage = _fromSocketToHistoryM.historyMessage,
        quickReplies = _fromSocketToHistoryM.quickReplies;
      var messageText = message.data.message.text;
      if (messageText) {
        dispatch(addMessage(historyMessage));
      }
      if (!scrollDataRef.current.isScrollButtonVisible) {
        scrollDataRef.current.scrollToBottom(0);
      }
      if (message.type === WSMessageType.IncomingMessage) {
        addNotification(historyMessage);
        dispatch(addUnreadedMessage(historyMessage));
        dispatch(addQuickReplies(quickReplies));
        if (messageText) {
          ymPushAnswerMesBot(messageText, authZoneConfig === null || authZoneConfig === void 0 ? void 0 : authZoneConfig.zoneType);
        }
      }
    }
  };
  useEffect(function () {
    addEventHandler('close', onClose);
    addEventHandler('open', onOpen);
    addEventHandler('message', function (e) {
      return onMessage(e);
    });
  }, []);
};